import { render, staticRenderFns } from "./PleitosDash.vue?vue&type=template&id=2a1a19fd"
import script from "./PleitosDash.vue?vue&type=script&lang=js"
export * from "./PleitosDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports